var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React from "react";
import { SiteSearchContext } from "../context/site-search-context";
import { useAvailableEntities } from "../context/available-entities-context";
import { useAppState } from "./use-app-state";
export var useSiteSearch = function () {
  var _a, _b;
  var _c = __read(useAppState(), 3),
    appState = _c[0],
    patchState = _c[1],
    patchAppState = _c[2];
  var context = React.useContext(SiteSearchContext);
  // assume that the search should span the available entities in the site
  var availableEntityTypeNames = useAvailableEntities();
  var patch = function (state) {
    patchAppState({
      search: __assign(__assign({}, appState.search), state)
    });
  };
  var entityTypeNames = context.entityTypeNames || availableEntityTypeNames;
  var show = function () {
    patch({
      isVisible: true,
      term: ''
    });
  };
  var hide = function () {
    patch({
      isVisible: false
    });
  };
  var toggle = function () {
    var _a;
    patch({
      isVisible: !((_a = appState === null || appState === void 0 ? void 0 : appState.search) === null || _a === void 0 ? void 0 : _a.isVisible)
    });
  };
  var patchTerm = function (term) {
    patch({
      term: term
    });
  };
  return {
    placeholder: context.placeholder,
    isAvailable: context.isAvailable,
    isVisible: (_a = appState.search) === null || _a === void 0 ? void 0 : _a.isVisible,
    term: (_b = appState.search) === null || _b === void 0 ? void 0 : _b.term,
    extraDataHooks: context.extraDataHooks || {},
    entityTypeNames: entityTypeNames,
    patchTerm: patchTerm,
    toggle: toggle,
    show: show,
    hide: hide
  };
};